import { Chain } from 'wagmi';

const elrondNativeCurency = {
  name: 'EGold',
  /** 2-6 characters long */
  symbol: 'EGLD',
  decimals: 18,
};

const tronNativeCurrency = {
  name: 'Tronix',
  /** 2-6 characters long */
  symbol: 'TRX',
  decimals: 18,
};

const OKXNativeCurency = {
  name: 'OKC Token',
  /** 2-6 characters long */
  symbol: 'OKT',
  decimals: 18,
};

const bscTestnetNativeCurrency = {
  name: 'Binance Coin',
  symbol: 'BNB',
  decimals: 18,
};

const hecoNativeCurrency = {
  name: 'Huobi Token',
  symbol: 'HT',
  decimals: 18,
};

const meterNativeCurrency = {
  name: 'Meter Governance',
  symbol: 'MTRG',
  decimals: 18,
};

const arbitrumNativeCurrency = {
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
};

const gnosisNativeCurrency = {
  name: 'Gnosis',
  symbol: 'GNO',
  decimals: 18,
};

const klaytnNativeCurrency = {
  name: 'Klaytn',
  symbol: 'KLAY',
  decimals: 18,
};

const auroraNativeCurrency = {
  name: 'Aurora',
  symbol: 'AUR',
  decimals: 18,
};

const bttcNativeCurrency = {
  name: 'BTTC',
  symbol: 'BTTC',
  decimals: 18,
};

const moonbeamNativeCurrency = {
  name: 'Moonriver',
  symbol: 'MOVR',
  decimals: 18,
};

const cronosNativeCurrency = {
  name: 'Cronos',
  symbol: 'CRO',
  decimals: 18,
};

const zksyncNativeCurrency = {
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
};

const harmonyNativeCurrency = {
  name: 'Harmony',
  symbol: 'ONE',
  decimals: 18,
};

const kavaNativeCurrency = {
  name: 'Kava',
  symbol: 'KAVA',
  decimals: 6,
};

const baseNativeCurrency = {
  name: 'Ethereum',
  symbol: 'ETH',
  decimals: 18,
};

const tonNativeCurrency = {
  name: 'Toncoin',
  symbol: 'TON',
  decimals: 9,
};

const artheraNativeCurrency = {
  name: 'Arthera',
  symbol: 'AA',
  decimals: 18,
};

const ELROND_CHAIN_ID = 999999;
const TRON_CHAIN_ID = 99999999;
const OKX_CHAIN_ID = 66;
const BSC_TESTNET_CHAIN_ID = 97;
const HECO_CHAIN_ID = 128;
const METER_CHAIN_ID = 82;
const ARBITRUM_CHAIN_ID = 42161;
const GNOSIS_CHAIN_ID = 100;
const KLAYTN_CHAIN_ID = 8217;
const AURORA_CHAIN_ID = 1313161554;
const BTTC_CHAIN_ID = 199;
const MOONBEAM_CHAIN_ID = 1284;
const CRONOS_CHAIN_ID = 25;
const ZKSYNC_CHAIN_ID = 324;
const HARMONY_CHAIN_ID = 1666600000;
const KAVA_CHAIN_ID = 2222;
const BASE_CHAIN_ID = 8453;
const TON_CHAIN_ID = 999998;
const ARTHERA_CHAIN_ID = 10242;

const elrondChain = {
  id: ELROND_CHAIN_ID,
  name: 'Chain ELROND',
  network: 'ELROND',
  nativeCurrency: elrondNativeCurency,
  rpcUrls: {
    default: {
      http: ['https://api.elrond.com/'],
    },
    public: {
      http: ['https://api.elrond.com/'],
    },
  },
  testnet: false,
} as Chain;

const tronChain = {
  id: TRON_CHAIN_ID,
  name: 'Chain TRON',
  network: 'TRON',
  nativeCurrency: tronNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://api.trongrid.io/'],
    },
    public: {
      http: ['https://api.trongrid.io/'],
    },
  },
  testnet: false,
} as Chain;

const okxChain = {
  id: OKX_CHAIN_ID,
  name: 'Chain OKX',
  blockExplorers: {
    default: {
      name: 'OKTC Explorer',
      url: 'https://www.okx.com/explorer/oktc',
    },
  },
  network: 'okx',
  nativeCurrency: OKXNativeCurency,
  rpcUrls: {
    default: {
      http: ['https://exchainrpc.okex.org'],
    },
    public: {
      http: ['https://exchainrpc.okex.org'],
    },
  },
  testnet: false,
} as Chain;

const bscTestnetChain = {
  id: BSC_TESTNET_CHAIN_ID,
  name: 'Binance Smart Chain Testnet',
  network: 'BSC_TESTNET',
  nativeCurrency: bscTestnetNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://bsc-testnet.publicnode.com'],
    },
    public: {
      http: ['https://bsc-testnet.publicnode.com'],
    },
  },
  testnet: true,
} as Chain;

const hecoChain = {
  id: HECO_CHAIN_ID,
  name: 'Huobi ECO Chain',
  network: 'HECO',
  nativeCurrency: hecoNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://http-mainnet.hecochain.com'],
    },
    public: {
      http: ['https://http-mainnet.hecochain.com'],
    },
  },
  testnet: false,
} as Chain;

const meterChain = {
  id: METER_CHAIN_ID,
  name: 'Meter',
  network: 'METER',
  nativeCurrency: meterNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://rpc.meter.io'],
    },
    public: {
      http: ['https://rpc.meter.io'],
    },
  },
  testnet: false,
} as Chain;

const arbitrumChain = {
  id: ARBITRUM_CHAIN_ID,
  name: 'Arbitrum',
  network: 'ARBITRUM',
  nativeCurrency: arbitrumNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://arb1.arbitrum.io/rpc'],
    },
    public: {
      http: ['https://arb1.arbitrum.io/rpc'],
    },
  },
  testnet: false,
} as Chain;

const gnosisChain = {
  id: GNOSIS_CHAIN_ID,
  name: 'Gnosis',
  network: 'GNOSIS',
  nativeCurrency: gnosisNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://rpc.gnosischain.com'],
    },
    public: {
      http: ['https://rpc.gnosischain.com'],
    },
  },
  testnet: false,
} as Chain;

const klaytnChain = {
  id: KLAYTN_CHAIN_ID,
  name: 'Klaytn',
  network: 'KLAYTN',
  nativeCurrency: klaytnNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://klaytn.blockpi.network/v1/rpc/public'],
    },
    public: {
      http: ['https://klaytn.blockpi.network/v1/rpc/public'],
    },
  },
  testnet: false,
} as Chain;

const auroraChain = {
  id: AURORA_CHAIN_ID,
  name: 'Aurora',
  network: 'AURORA',
  nativeCurrency: auroraNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://endpoints.omniatech.io/v1/aurora/mainnet/public'],
    },
    public: {
      http: ['https://endpoints.omniatech.io/v1/aurora/mainnet/public'],
    },
  },
  testnet: false,
} as Chain;

const bttcChain = {
  id: BTTC_CHAIN_ID,
  name: 'BTTC',
  network: 'BTTC',
  nativeCurrency: bttcNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://rpc.bittorrentchain.io'],
    },
    public: {
      http: ['https://rpc.bittorrentchain.io'],
    },
  },
  testnet: false,
} as Chain;

const moonbeamChain = {
  id: MOONBEAM_CHAIN_ID,
  name: 'Moonbeam',
  network: 'MOONBEAM',
  nativeCurrency: moonbeamNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://rpc.api.moonbeam.network'],
    },
    public: {
      http: ['https://rpc.api.moonbeam.network'],
    },
  },
  testnet: false,
} as Chain;

const cronosChain = {
  id: CRONOS_CHAIN_ID,
  name: 'Cronos',
  network: 'CRONOS',
  nativeCurrency: cronosNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://cronos-evm.publicnode.com'],
    },
    public: {
      http: ['https://cronos-evm.publicnode.com'],
    },
  },
  testnet: false,
} as Chain;

const zksyncChain = {
  id: ZKSYNC_CHAIN_ID,
  name: 'zkSync',
  network: 'ZKSYNC',
  nativeCurrency: zksyncNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://mainnet.era.zksync.io'],
    },
    public: {
      http: ['https://mainnet.era.zksync.io'],
    },
  },
  testnet: false,
} as Chain;

const harmonyChain = {
  id: HARMONY_CHAIN_ID,
  name: 'Harmony',
  network: 'HARMONY',
  nativeCurrency: harmonyNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://api.harmony.one'],
    },
    public: {
      http: ['https://api.harmony.one'],
    },
  },
  testnet: false,
} as Chain;

const kavaChain = {
  id: KAVA_CHAIN_ID,
  name: 'Kava',
  network: 'KAVA',
  nativeCurrency: kavaNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://evm2.kava.io'],
    },
    public: {
      http: ['https://evm2.kava.io'],
    },
  },
  testnet: false,
} as Chain;

const baseChain = {
  id: BASE_CHAIN_ID,
  name: 'Base',
  network: 'BASE',
  nativeCurrency: baseNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://base.meowrpc.com'],
    },
    public: {
      http: ['https://base.meowrpc.com'],
    },
  },
  testnet: false,
} as Chain;

const tonChain = {
  id: TON_CHAIN_ID,
  name: 'TON',
  network: 'TON',
  nativeCurrency: tonNativeCurrency,
  rpcUrls: {
    default: {
      http: ['ADNL'],
    },
    public: {
      http: ['ADNL'],
    },
  },
  testnet: false,
} as Chain;

const artheraChain = {
  id: ARTHERA_CHAIN_ID,
  name: 'Arthera Mainnet',
  network: 'ARTHERA',
  nativeCurrency: artheraNativeCurrency,
  rpcUrls: {
    default: {
      http: ['https://rpc.arthera.net'],
    },
    public: {
      http: ['https://rpc.arthera.net'],
    },
  },
  testnet: false,
} as Chain;

export {
  ELROND_CHAIN_ID,
  TRON_CHAIN_ID,
  OKX_CHAIN_ID,
  BSC_TESTNET_CHAIN_ID,
  HECO_CHAIN_ID,
  METER_CHAIN_ID,
  ARBITRUM_CHAIN_ID,
  GNOSIS_CHAIN_ID,
  KLAYTN_CHAIN_ID,
  AURORA_CHAIN_ID,
  BTTC_CHAIN_ID,
  MOONBEAM_CHAIN_ID,
  CRONOS_CHAIN_ID,
  ZKSYNC_CHAIN_ID,
  HARMONY_CHAIN_ID,
  KAVA_CHAIN_ID,
  BASE_CHAIN_ID,
  TON_CHAIN_ID,
  ARTHERA_CHAIN_ID,
  elrondChain,
  tronChain,
  okxChain,
  bscTestnetChain,
  hecoChain,
  meterChain,
  arbitrumChain,
  gnosisChain,
  klaytnChain,
  auroraChain,
  bttcChain,
  moonbeamChain,
  cronosChain,
  zksyncChain,
  harmonyChain,
  kavaChain,
  baseChain,
  tonChain,
  artheraChain,
};
